import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dcbe1d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "well well-sm" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = { class: "q-pa-md" }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","margin-bottom":"15px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Pontaj proiect", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { style: {"display":"flex","align-items":"start"} }
const _hoisted_10 = { style: {"width":"65%","display":"flex","flex-direction":"row"} }
const _hoisted_11 = { style: {"display":"flex","flex-direction":"column","width":"100%"} }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Proiect", -1))
const _hoisted_14 = { class: "col-8 form__label__black" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Descriere", -1))
const _hoisted_17 = { class: "col-8 form__label__black" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "La data", -1))
const _hoisted_20 = { class: "col-8 form__label__black" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Ore pontate", -1))
const _hoisted_23 = { class: "col-8 form__label__black" }
const _hoisted_24 = {
  key: 0,
  clas: "row",
  style: {"margin-top":"5px","margin-bottom":"15px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_TaskList = _resolveComponent("TaskList")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingData)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "4em",
          class: "absolute-center"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_q_form, { ref: "myForm" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  })
                      }, _hoisted_8, 2)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.proiect.proiect_id?.denumire), 1)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.proiect.descriere_proiect), 1)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.proiect.pontaj_date), 1)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.proiect.efort), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.proiect.stare !== 'initiat')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(_component_TaskList, {
                          appid: _ctx.appid,
                          task: _ctx.task,
                          onState: _ctx.onState,
                          isSuccess: _ctx.isSuccess
                        }, null, 8, ["appid", "task", "onState", "isSuccess"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 512)
        ]))
  ]))
}